
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_770_8894)","fill":"#fff"}},[_c('path',{attrs:{"d":"M11.156 21.35c-.212 0-.423-.032-.625-.097-4.78-1.531-7.87-5.187-7.87-9.313V4.457c0-.64.473-1.187 1.124-1.301C6.307 2.713 8.506 1.8 10.32.44a1.401 1.401 0 011.67 0c1.815 1.359 4.014 2.272 6.536 2.715.651.114 1.124.661 1.124 1.301v7.483c0 4.126-3.09 7.782-7.87 9.313a2.06 2.06 0 01-.625.097zM3.96 4.082a.384.384 0 00-.321.375v7.483c0 3.713 2.827 7.019 7.201 8.42.204.066.43.065.635 0 4.374-1.401 7.2-4.706 7.2-8.42V4.457a.384.384 0 00-.321-.375c-2.679-.47-5.02-1.445-6.96-2.897a.397.397 0 00-.473 0C8.98 2.637 6.638 3.612 3.96 4.082z"}}),_c('path',{attrs:{"d":"M14.919 8.212a.685.685 0 00-.796.161l-3.621 3.993-1.86-2.067a.684.684 0 10-1.015.919l2.505 2.751a.5.5 0 00.74 0l4.264-4.674a.685.685 0 00-.217-1.083z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_770_8894"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h22.312v21.515H0z"}})])])])
          )
        }
      }
    